import { ADD, DELETE, EDIT, LIST, VIEW } from "const"
import { LangType } from "client/store"
import Lang from "client/store/lang"

import * as Const from "./const"
import {
    PermissionStructure,
    CommonPermissions,
    CommonPermissionsSectioned,
} from "./types"
import {
    copyPermissionRow,
    commonPermissionRow,
} from "./functions"

// eslint-disable-next-line import/prefer-default-export
export const createLifecyclePermissions = (targetLang?: LangType) => {
    const lang = targetLang || Lang
    const structure: PermissionStructure = {
        lifecycle: [
            {
                permissionId: Const.PRM_LIFECYCLE,
                title: lang.lifecycle,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_LIFECYCLE_PERMISSIONS,
                title: lang.lifecyclePermissions,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_LIFECYCLE_PHASE_LIST,
                title: lang.phaseList,
                unused: [LIST, ADD, DELETE],
            },
            {
                permissionId: Const.PRM_LIFECYCLE_POPULATE,
                title: lang.populate,
                unused: [LIST, VIEW, EDIT],
            },
        ],
    }

    const { permissions, permissionsSectioned } = copyPermissionRow(structure, commonPermissionRow)
    return {
        permissions: <CommonPermissions>permissions,
        permissionsSectioned: <CommonPermissionsSectioned>permissionsSectioned,
    }
}
